<template>
<div class="chapter">
<div class="inner_page">
<p class="block_5">
<span class="text_" lang="en">
</span><span class="block_6" lang="en">“La Terre </span><span class="block_6" lang="en">Vorace</span><span class="block_6" lang="en"> </span><span class="block_6" lang="en">— </span><span class="block_6" lang="en">Livre</span><span class="block_6" lang="en"> </span><span class="block_6" lang="en">Élémentaire</span><span class="block_6" lang="en"> I</span><span class="block_6" lang="en">I</span><span class="block_6" lang="en">”</span></p>
<p class="block_5"><span lang="en">Écrit</span><span lang="en"> Par Rain Oxford</span></p>
<p class="block_5"><span lang="en">Copyright © 201</span><span lang="en">6</span><span lang="en"> Rain Oxford</span></p>
<p class="block_5"><span lang="en">Tous</span><span lang="en"> </span><span lang="en">droits</span><span lang="en"> </span>réservés</p>
<p class="block_5">Distribué par Babelcube, Inc. </p>
<p class="block_5">www.babelcube.com </p>
<p class="block_5"><span lang="en">Traduit</span><span lang="en"> par Camille </span><span lang="en">Fankhauser</span></p>
<p class="block_5"><span lang="en">“</span><span lang="en">Babelcube</span><span lang="en"> Books” et “</span><span lang="en">Babelcube</span><span lang="en">” </span><span lang="en">sont</span><span lang="en"> des marques </span>déposées de<span lang="en"> </span><span lang="en">Babelcube</span><span lang="en"> Inc.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?5697bb53